import React, { useEffect, useState } from "react";
import SkillFinder from "./SkillFinder";
import YoEslider from "./YOEslider";

const Skills = (props) => {
  const [SkillsEntered, setSkillsEntered] = useState(true);
  const [SelectedSkills, setSelectedSkills] = useState([]);

  useEffect(() => {
    setSelectedSkills(props.UserInfo.skills);
  }, []);

  const saveSkills = (Skills) => {
    setSelectedSkills(Skills);
    props.SaveSkills(Skills);
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const inputsChangeActions = () => {
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    props.SetHasMadeChanges(true);
    props.SetHasUnsavedChanges(true);
  };

  return (
    <div className="skills-settings">
      <h1 className="skills-settings-title">
        {translateText("years_of_experience")}
      </h1>
      <YoEslider
        Default={
          props.UserInfo.yearsOfExperience
            ? props.UserInfo.yearsOfExperience
            : 1
        }
        ChangeEvent={() => inputsChangeActions()}
      />
      <section className="step-row options-row">
        <p className="row-label skills-label">
          {translateText("wizard_select_top5_skills")} <p>*</p>
        </p>
        <SkillFinder
          AllSelected={() => setSkillsEntered(true)}
          NotAllSelected={() => setSkillsEntered(false)}
          PreselectedSkills={SelectedSkills}
          PlaceHolder={translateText("search") + " ..."}
          UserInfo={props.UserInfo}
          SaveSkills={(Skills) => saveSkills(Skills)}
          LangData={props.LangData}
          ChangeEvent={() => inputsChangeActions()}
        />
      </section>
    </div>
  );
};

export default Skills;
